import { useForm } from "react-hook-form";
import { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { AppContext, mainAPikey } from "../../../ContextApi";
import { FaDeleteLeft } from "react-icons/fa6";
import { IoCloudUploadOutline } from "react-icons/io5";


const ReplyQueriesForm = ({selectedQueryId , ticketDetailsData , fetchChatList}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({});

  const { requestOptions } = useContext(AppContext);

  const onSubmit = (data) => {
    setIsLoading(true);

    const formdata = new FormData();
    for (let i = 0; i < selectedFiles.length; i++) {
      formdata.append("documents[]", selectedFiles[i]?.file); // Ensure selectedFiles[i] is a File
    }

    formdata.append("message", data?.message);
    formdata.append("query_id", selectedQueryId);

    const requestOptionsCopy = {
      ...requestOptions,
      method: "POST",
      body: formdata,
    };

    // Remove content-type header if present:
    if (requestOptionsCopy.headers?.["Content-Type"]) {
      delete requestOptionsCopy.headers["Content-Type"];
    }

    fetch(
      `${process.env.REACT_APP_API_URL}/${mainAPikey}/employee/ticket-reply`,
      requestOptionsCopy
    )
      .then((response) => response.json())
      .then((res) => {
        setIsLoading(false);
        if (res.success) {
          toast.success(res.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          reset();
          setSelectedFiles(null);
          fetchChatList();
        } else {
          toast.error(res.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error submitting form:", error);
        toast.error("Something went wrong!");
      });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFiles((files) => [...files, { file }]);
  };

  const handleDeleteFile = (select_file) => {
    setSelectedFiles(() =>
      selectedFiles?.filter(
        (sel_file) => sel_file.file.name !== select_file?.file?.name
      )
    );
  };

  return (
    <div className="employee-queries-form-main-cover">
      <h3 className="ticket-header">
        Ticket <span className="ticket-number">{ticketDetailsData?.ticket_id}</span>
      </h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-12">
            <div className="form-input-box mb-3">
              <div className="form-input">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Please write your query in the following box{" "}
                  <span className="required-input">*</span>
                </label>
                <textarea
                  className="form-control"
                  id=""
                  aria-describedby="emailHelp"
                  placeholder="Write a reply message"
                  {...register("message", {
                    required: "message is required",
                  })}
                  rows={3}
                />
                {errors.message && (
                  <small className="text-danger">
                    {errors.message.message || ""}
                  </small>
                )}
              </div>
            </div>
          </div>

          <div className="my-document-wrapper">
            <div className="form-input-box">
              <div className="form-input">
                <label className="form-label upload-label">
                  Upload Document
                </label>
                <div
                  className="upload-area"
                  onClick={() => document.getElementById("fileInput").click()}
                >
                    <IoCloudUploadOutline/>
                  <span>
                    Click to upload (xls, xlsx, doc, docx, png, jpeg, jpg, pdf)
                  </span>
                </div>
                <input
                  type="file"
                  id="fileInput"
                  accept=".pdf,.png,.jpg,.jpeg"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    handleFileChange(e);
                  }}
                />
              </div>
              {selectedFiles?.map((select_file, index) => (
                <div key={index} className="selected-file-box">
                  <span className="file-name">{select_file?.file?.name}</span>
                  <button
                    className="queries-delete-btn"
                    type="button"
                    onClick={() => handleDeleteFile(select_file)}
                  >
                    <FaDeleteLeft />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="submit-btn-box">
          <input
            disabled={isLoading}
            type="submit"
            className="register-form-btn mt-4 mb-3"
            value={isLoading ? "please wait..." : "Reply"}
          ></input>
        </div>
      </form>
    </div>
  );
};

export default ReplyQueriesForm;
